var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('div', {
    staticClass: "float-right pr-4"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.draw
    }
  }, [_c('v-icon', [_vm._v("mdi-refresh")])], 1)], 1), _c('p', {
    staticClass: "title px-4 primary--text",
    on: {
      "click": _vm.draw
    }
  }, [_vm._v(_vm._s(_vm.$t('Talent')))]), _c('div', {
    ref: "talent",
    staticStyle: {
      "height": "320px"
    }
  }), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale == 'ja',
      expression: "$i18n.locale=='ja'"
    }],
    attrs: {
      "target": "_blank",
      "href": _vm.$const.wikiwiki._.format('システム/評価値')
    }
  }, [_c('v-list-item-title', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s('評価値') + " - " + _vm._s(_vm.$t('Wikiwiki.Title')))]), _c('v-list-item-action', {
    staticClass: "ma-0"
  }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }